import { useEffect, useState } from 'react';
import { Table, Card, InputNumber, Button, Switch, message, Typography, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;
const fmt = (v) => Number(v || 0).toLocaleString('uz-UZ');

export default function GovTariffsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const r = await api.get('/admingov/tariffs');
      setData(r.data.data);
    } catch { message.error('Xatolik'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleSave = async (record) => {
    try {
      await api.put(`/admingov/tariffs/${record.id}`, {
        price_monthly: record.price_monthly,
        trial_days: record.trial_days,
        active: record.active,
      });
      message.success('Saqlandi');
      setEditing(null);
      fetchData();
    } catch { message.error('Xatolik'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: 'Xizmat turi', dataIndex: 'type_name' },
    {
      title: "Oylik narx (so'm)", dataIndex: 'price_monthly',
      render: (v, r) => editing === r.id ? (
        <InputNumber value={v} onChange={val => setData(data.map(d => d.id === r.id ? { ...d, price_monthly: val } : d))} style={{ width: 150 }} />
      ) : fmt(v) + " so'm"
    },
    {
      title: 'Sinov kunlari', dataIndex: 'trial_days',
      render: (v, r) => editing === r.id ? (
        <InputNumber value={v} onChange={val => setData(data.map(d => d.id === r.id ? { ...d, trial_days: val } : d))} style={{ width: 80 }} />
      ) : v + ' kun'
    },
    {
      title: 'Faol', dataIndex: 'active',
      render: (v, r) => <Switch checked={!!v} disabled={editing !== r.id}
        onChange={val => setData(data.map(d => d.id === r.id ? { ...d, active: val ? 1 : 0 } : d))} />
    },
    {
      title: 'Amal', width: 100,
      render: (_, r) => editing === r.id ? (
        <Space>
          <Button size="small" type="primary" icon={<SaveOutlined />} onClick={() => handleSave(r)}>Saqlash</Button>
          <Button size="small" onClick={() => { setEditing(null); fetchData(); }}>Bekor</Button>
        </Space>
      ) : (
        <Button size="small" onClick={() => setEditing(r.id)}>Tahrirlash</Button>
      )
    },
  ];

  return (
    <div>
      <Title level={3}>Tariflar boshqaruvi</Title>
      <Card style={{ borderRadius: 12 }}>
        <Table dataSource={data} columns={columns} rowKey="id" loading={loading} pagination={false} size="small" />
      </Card>
    </div>
  );
}
